export const machineStatusColor = {
  1: '#43A34B', // ACTIVE
  2: '#026FCF', // CHANGE
  3: '#FF33AA', // SETUP
  4: '#282F34', // NOT PRODUCTIVE
};

export const machineStatus = {
  ACTIVE: 'Active', // ACTIVE
  CHANGE: 'Change', // CHANGE
  SETUP: 'Setup', // SETUP
  NOTPRODUCTIVE: 'NotProductive', // NOT PRODUCTIVE
};

export const machineStatusName = {
  [machineStatus.ACTIVE]: 'Active', // ACTIVE
  [machineStatus.CHANGE]: 'Change', // CHANGE
  [machineStatus.SETUP]: 'Setup', // SETUP
  [machineStatus.NOTPRODUCTIVE]: 'Not Productive', // NOT PRODUCTIVE
};

export const machineStatusColorName = {
  [machineStatus.ACTIVE]: 'Status / Light / Active', // ACTIVE
  [machineStatus.CHANGE]: 'Status / Light / Change', // Change
  [machineStatus.SETUP]: 'Status / Light / Setup', // SETUP
  [machineStatus.NOTPRODUCTIVE]: 'Status / Light / Not Productive', // NOT PRODUCTIVE
};

export const machineStatusSmall = {
  Active: 1,
  Change: 2,
  Setup: 3,
  NotProductive: 4,
};

export const getColorBasedOnMachineStatus = (status: string) => {
  const statusName = machineStatusName[status];
  return `Status/Light/${statusName}`;
};
